import { createFileRoute, redirect } from '@tanstack/react-router';

// Notes now live in the Library, under its Notes view.
export const Route = createFileRoute('/$spaceSlug/notes')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$spaceSlug/library', params, search: { kind: 'note' }, replace: true });
  },
});
